import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ChoiceDataType } from 'yo-services/yolabs/services/poplarfrontend/enums_pb';
import * as Yup from 'yup';
import { addBusinessDays } from 'date-fns';
import { useEffect, useMemo } from 'react';
import { I_DO_NOT_KNOW_ID } from '@poplar/constants/intake';
import { Radio, Textarea, Select } from '@yoweb/ui/components/form';
import { Grid } from '@yoweb/ui/components/Grid';
import { Text } from '@yoweb/ui/components/typography';
import { DatePicker } from '@yoweb/ui/components/DatePicker';
import { compareChoiceValues, getChoiceValue, getChoiceAnswerValue, getFormattedChoiceValue } from './utils';
import AddressFormElements from '@poplar/components/AddressFormElements';
import { validatePostalCode } from '@yoweb/utils/postalCode';
import { DateTime, getBaseSchema as getDateTimeBaseSchema } from './DateTime';
import { STANDARD_FIELD_LIMIT } from '@poplar/constants/app';
import { Box } from '@yoweb/ui/components/Box';
import { useTranslation } from '@yoweb/next-i18next';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import { useUser } from '@poplar/hooks/useUser';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var OTHER_OPTION_VALUE = 'other-option-value';

var SingleChoiceWrapper = function SingleChoiceWrapper(_ref) {
  var _values$questionId, _singleChoiceAnswer$c;

  var id = _ref.id,
      singleChoiceAnswer = _ref.singleChoiceAnswer,
      instructionHint = _ref.instructionHint,
      isDisabled = _ref.isDisabled,
      children = _ref.children,
      setSelectedAnswerOptionDependencies = _ref.setSelectedAnswerOptionDependencies,
      formikProps = _ref.formikProps;

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  var _id$split = id.split('.'),
      _id$split2 = _slicedToArray(_id$split, 2),
      questionId = _id$split2[0],
      index = _id$split2[1];

  var values = formikProps.values,
      setFieldValue = formikProps.setFieldValue;

  var _ref2 = values === null || values === void 0 ? void 0 : (_values$questionId = values[questionId]) === null || _values$questionId === void 0 ? void 0 : _values$questionId[index],
      selected = _ref2.selected;

  if (!singleChoiceAnswer) {
    return null;
  }

  return /*#__PURE__*/_jsxs(Grid, {
    rowGap: "small3",
    children: [instructionHint && /*#__PURE__*/_jsx(Text, {
      size: "md",
      children: instructionHint
    }), !singleChoiceAnswer.displayAsDropdown && ((_singleChoiceAnswer$c = singleChoiceAnswer.choicesList) === null || _singleChoiceAnswer$c === void 0 ? void 0 : _singleChoiceAnswer$c.map(function (choice, choiceIndex) {
      return /*#__PURE__*/_jsx(SingleChoiceRadio, {
        choice: choice,
        choiceIndex: choiceIndex // eslint-disable-next-line react/no-array-index-key
        ,
        id: id,
        selected: selected,
        singleChoiceAnswer: singleChoiceAnswer,
        isDisabled: isDisabled,
        setFieldValue: setFieldValue,
        setSelectedAnswerOptionDependencies: setSelectedAnswerOptionDependencies
      }, "".concat(id, ".").concat(choiceIndex));
    })), !singleChoiceAnswer.displayAsDropdown && singleChoiceAnswer.displayOtherField && /*#__PURE__*/_jsxs(Grid, {
      rowGap: "normal2",
      children: [/*#__PURE__*/_jsx(Radio, {
        id: "".concat(id, ".other"),
        name: "".concat(id, ".selected"),
        value: OTHER_OPTION_VALUE,
        disabled: isDisabled,
        children: t('todo-intake.other')
      }), selected === OTHER_OPTION_VALUE && children]
    }), singleChoiceAnswer.displayAsDropdown && /*#__PURE__*/_jsx(SingleChoiceSelect, {
      id: id,
      selected: selected,
      singleChoiceAnswer: singleChoiceAnswer,
      isDisabled: isDisabled,
      setFieldValue: setFieldValue,
      setSelectedAnswerOptionDependencies: setSelectedAnswerOptionDependencies,
      children: children
    })]
  });
};

var SingleChoiceRadio = function SingleChoiceRadio(_ref3) {
  var choice = _ref3.choice,
      choiceIndex = _ref3.choiceIndex,
      singleChoiceAnswer = _ref3.singleChoiceAnswer,
      selected = _ref3.selected,
      id = _ref3.id,
      isDisabled = _ref3.isDisabled,
      setFieldValue = _ref3.setFieldValue,
      setSelectedAnswerOptionDependencies = _ref3.setSelectedAnswerOptionDependencies;

  var _useIntlMeta = useIntlMeta(),
      locale = _useIntlMeta.locale,
      country = _useIntlMeta.country;

  var _useUser = useUser(),
      timeZone = _useUser.timeZone;

  var choiceValue = getChoiceValue(choice, singleChoiceAnswer.choiceDataType, country);
  var isChecked = compareChoiceValues(selected, choiceValue !== null && choiceValue !== void 0 ? choiceValue : '', singleChoiceAnswer.choiceDataType);
  useEffect(function () {
    if (isChecked && choice.determinesAnswerOptionsList.length > 0) {
      setSelectedAnswerOptionDependencies(choice.determinesAnswerOptionsList);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [setSelectedAnswerOptionDependencies]);
  return /*#__PURE__*/_jsx(Radio, {
    id: "".concat(id, ".").concat(choiceIndex),
    name: "".concat(id, ".selected"),
    disabled: isDisabled,
    onChange: function onChange() {
      setFieldValue("".concat(id, ".selected"), choiceValue);
      setSelectedAnswerOptionDependencies(choice.determinesAnswerOptionsList);
    },
    checked: isChecked,
    children: getFormattedChoiceValue(choice, singleChoiceAnswer.choiceDataType, locale, timeZone)
  });
};

var SingleChoiceSelect = function SingleChoiceSelect(_ref4) {
  var _singleChoiceAnswer$c3;

  var singleChoiceAnswer = _ref4.singleChoiceAnswer,
      selected = _ref4.selected,
      id = _ref4.id,
      isDisabled = _ref4.isDisabled,
      setFieldValue = _ref4.setFieldValue,
      setSelectedAnswerOptionDependencies = _ref4.setSelectedAnswerOptionDependencies,
      children = _ref4.children;

  var _useTranslation2 = useTranslation('common'),
      t = _useTranslation2.t;

  var _useIntlMeta2 = useIntlMeta(),
      country = _useIntlMeta2.country;

  var _useUser2 = useUser(),
      timeZone = _useUser2.timeZone;

  var choiceValueMap = useMemo(function () {
    var _singleChoiceAnswer$c2;

    var initialChoiceValueMap = {};
    singleChoiceAnswer === null || singleChoiceAnswer === void 0 ? void 0 : (_singleChoiceAnswer$c2 = singleChoiceAnswer.choicesList) === null || _singleChoiceAnswer$c2 === void 0 ? void 0 : _singleChoiceAnswer$c2.forEach(function (choice) {
      return initialChoiceValueMap[getFormattedChoiceValue(choice, singleChoiceAnswer.choiceDataType, country, timeZone)] = {
        value: getChoiceValue(choice, singleChoiceAnswer.choiceDataType, country),
        choice: choice
      };
    });
    return initialChoiceValueMap; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var value = useMemo(function () {
    if (selected === OTHER_OPTION_VALUE) {
      return OTHER_OPTION_VALUE;
    } else if (selected) {
      return getFormattedChoiceValue(getChoiceAnswerValue(selected, singleChoiceAnswer.choiceDataType), singleChoiceAnswer.choiceDataType, country, timeZone);
    }

    return '';
  }, [selected, country, singleChoiceAnswer.choiceDataType, timeZone]);
  useEffect(function () {
    if (selected) {
      var _choiceValueMap;

      var determinesAnswerOptionsList = (_choiceValueMap = choiceValueMap[selected]) === null || _choiceValueMap === void 0 ? void 0 : _choiceValueMap.choice.determinesAnswerOptionsList;

      if ((determinesAnswerOptionsList === null || determinesAnswerOptionsList === void 0 ? void 0 : determinesAnswerOptionsList.length) > 0) {
        setSelectedAnswerOptionDependencies(determinesAnswerOptionsList);
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [setSelectedAnswerOptionDependencies]);
  var answerOptions = singleChoiceAnswer === null || singleChoiceAnswer === void 0 ? void 0 : (_singleChoiceAnswer$c3 = singleChoiceAnswer.choicesList) === null || _singleChoiceAnswer$c3 === void 0 ? void 0 : _singleChoiceAnswer$c3.map(function (choice) {
    var option = getFormattedChoiceValue(choice, singleChoiceAnswer.choiceDataType, country, timeZone);
    return {
      value: option,
      label: option
    };
  });

  if (singleChoiceAnswer.displayOtherField) {
    answerOptions.push({
      value: OTHER_OPTION_VALUE,
      label: t('todo-intake.other')
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Box, {
      mb: "small3",
      children: /*#__PURE__*/_jsx(Select, {
        id: id,
        "data-testid": id,
        name: "".concat(id, ".selected"),
        label: singleChoiceAnswer.inputFieldHint,
        options: answerOptions,
        value: value,
        disabled: isDisabled,
        onChangeCallback: function onChangeCallback(val) {
          if (val !== OTHER_OPTION_VALUE) {
            var choiceValue = choiceValueMap[val];
            setFieldValue("".concat(id, ".selected"), choiceValue === null || choiceValue === void 0 ? void 0 : choiceValue.value);
            setSelectedAnswerOptionDependencies(choiceValue === null || choiceValue === void 0 ? void 0 : choiceValue.choice.determinesAnswerOptionsList);
          }
        }
      })
    }), selected === OTHER_OPTION_VALUE && children]
  });
};

var getInitialValuesByType = function getInitialValuesByType(singleChoiceAnswer, country) {
  var includeInitialValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var type = singleChoiceAnswer.choiceDataType;
  var initialValue = getChoiceValue(singleChoiceAnswer.answeredValue, type, country);
  var emptyTypeValue = getChoiceValue(undefined, type, country);
  var preFilledOther = singleChoiceAnswer.otherNoteFromMemberProfile;
  var defaultOther = preFilledOther || emptyTypeValue;

  if (!includeInitialValues) {
    return {
      selected: emptyTypeValue,
      other: emptyTypeValue
    };
  }

  if (compareChoiceValues(initialValue, emptyTypeValue, type)) {
    var preselected = singleChoiceAnswer.choicesList.find(function (choice) {
      return choice.preselected;
    });

    if (preselected) {
      return {
        selected: getChoiceValue(preselected, type, country),
        other: defaultOther
      };
    }

    return {
      selected: preFilledOther ? OTHER_OPTION_VALUE : emptyTypeValue,
      other: defaultOther
    };
  } // Determine if initial value is from choices or 'other'


  var isInitialFromChoices = singleChoiceAnswer.choicesList.filter(function (choice) {
    return compareChoiceValues(initialValue, getChoiceValue(choice, type, country), type);
  }).length > 0;

  if (isInitialFromChoices) {
    return {
      selected: initialValue,
      other: defaultOther
    };
  }

  return {
    selected: OTHER_OPTION_VALUE,
    other: initialValue
  };
};

export var getSingleChoiceInitialValues = function getSingleChoiceInitialValues(singleChoiceAnswer, country, includeInitialValues) {
  return singleChoiceAnswer ? getInitialValuesByType(singleChoiceAnswer, country, includeInitialValues) : undefined;
};
export var getSingleChoiceValidationSchema = function getSingleChoiceValidationSchema(singleChoiceAnswer, isOptional, country, t) {
  var validationRequired = t('validation.required');
  var base = Yup.string().notRequired();
  var required = Yup.string().required(validationRequired);
  var singleChoiceValidationSchema = Yup.object().when(I_DO_NOT_KNOW_ID, {
    is: true,
    then: Yup.object().shape({
      selected: base,
      other: base
    }),
    otherwise: Yup.object().shape({
      selected: isOptional ? base : required,
      other: Yup.string().when('selected', {
        is: OTHER_OPTION_VALUE,
        then: required,
        otherwise: base
      })
    })
  });

  switch (singleChoiceAnswer === null || singleChoiceAnswer === void 0 ? void 0 : singleChoiceAnswer.choiceDataType) {
    case ChoiceDataType.CHOICE_DATA_TYPE_LOCALIZED_TEXT:
    case ChoiceDataType.CHOICE_DATA_TYPE_STRING:
    case ChoiceDataType.CHOICE_DATA_TYPE_DATE:
      return singleChoiceValidationSchema;

    case ChoiceDataType.CHOICE_DATA_TYPE_DATE_TIME:
      {
        var baseSchema = getDateTimeBaseSchema(t, false);
        var baseSchemaRequired = getDateTimeBaseSchema(t, true);
        return Yup.object().when(I_DO_NOT_KNOW_ID, {
          is: true,
          then: Yup.object().shape({
            selected: baseSchema,
            other: baseSchema
          }),
          otherwise: Yup.object().shape({
            selected: Yup.lazy(function (value) {
              return typeof value === 'object' ? baseSchemaRequired : Yup.string();
            }),
            other: Yup.object().when('selected', {
              is: OTHER_OPTION_VALUE,
              then: baseSchemaRequired,
              otherwise: baseSchema
            })
          })
        });
      }

    case ChoiceDataType.CHOICE_DATA_TYPE_POSTAL_ADDRESS:
      {
        var addressSchema = Yup.object().shape({
          street1: Yup.string().trim().required(validationRequired),
          street2: Yup.string().trim().ensure(),
          city: Yup.string().trim().required(validationRequired),
          region: Yup.string().trim().required(validationRequired),
          postalCode: Yup.string().trim().required(validationRequired).test({
            message: t('validation.zip-code'),
            test: function test(value) {
              return value ? validatePostalCode(country, value) : false;
            }
          }),
          country: Yup.string().trim().required(validationRequired)
        });
        return Yup.object().when(I_DO_NOT_KNOW_ID, {
          is: true,
          then: Yup.object().shape({
            selected: Yup.object(),
            other: Yup.object()
          }),
          otherwise: Yup.object().shape({
            selected: Yup.lazy(function (value) {
              return typeof value === 'object' ? addressSchema : Yup.string();
            }),
            other: Yup.object().when('selected', {
              is: OTHER_OPTION_VALUE,
              then: addressSchema,
              otherwise: Yup.object().notRequired()
            })
          })
        });
      }

    default:
      {
        throw new Error("Invalid choice data type: ".concat(singleChoiceAnswer === null || singleChoiceAnswer === void 0 ? void 0 : singleChoiceAnswer.choiceDataType));
      }
  }
};
export var SingleChoiceElement = function SingleChoiceElement(props) {
  var _values$questionId2;

  var id = props.id,
      singleChoiceAnswer = props.singleChoiceAnswer,
      isDisabled = props.isDisabled,
      formikProps = props.formikProps;

  var _id$split3 = id.split('.'),
      _id$split4 = _slicedToArray(_id$split3, 2),
      questionId = _id$split4[0],
      index = _id$split4[1];

  var values = formikProps.values,
      setFieldValue = formikProps.setFieldValue;

  var _ref5 = values === null || values === void 0 ? void 0 : (_values$questionId2 = values[questionId]) === null || _values$questionId2 === void 0 ? void 0 : _values$questionId2[index],
      selected = _ref5.selected,
      other = _ref5.other;

  switch (singleChoiceAnswer === null || singleChoiceAnswer === void 0 ? void 0 : singleChoiceAnswer.choiceDataType) {
    case ChoiceDataType.CHOICE_DATA_TYPE_LOCALIZED_TEXT:
    case ChoiceDataType.CHOICE_DATA_TYPE_STRING:
      {
        var _singleChoiceAnswer$o, _singleChoiceAnswer$o2, _singleChoiceAnswer$o3;

        return /*#__PURE__*/_jsx(SingleChoiceWrapper, _objectSpread(_objectSpread({}, props), {}, {
          children: /*#__PURE__*/_jsx(Textarea, {
            id: "".concat(id, ".otherInput"),
            name: "".concat(id, ".other"),
            type: "text",
            label: (_singleChoiceAnswer$o = singleChoiceAnswer.otherFieldHint) !== null && _singleChoiceAnswer$o !== void 0 ? _singleChoiceAnswer$o : '',
            disabled: isDisabled,
            maxLength: (_singleChoiceAnswer$o2 = (_singleChoiceAnswer$o3 = singleChoiceAnswer.otherNoteMaxLength) === null || _singleChoiceAnswer$o3 === void 0 ? void 0 : _singleChoiceAnswer$o3.value) !== null && _singleChoiceAnswer$o2 !== void 0 ? _singleChoiceAnswer$o2 : STANDARD_FIELD_LIMIT,
            rows: 1
          })
        }));
      }

    case ChoiceDataType.CHOICE_DATA_TYPE_DATE:
      {
        return /*#__PURE__*/_jsx(SingleChoiceWrapper, _objectSpread(_objectSpread({}, props), {}, {
          children: /*#__PURE__*/_jsx(DatePicker, {
            label: singleChoiceAnswer.otherFieldHint || '--',
            id: "".concat(id, ".otherInputDate"),
            name: "".concat(id, ".other"),
            disabled: isDisabled,
            minDate: addBusinessDays(new Date(), 3),
            selected: other ? new Date(Number(other) * 1000) : undefined,
            onChange: function onChange(date) {
              if (date) {
                setFieldValue(id, {
                  selected: selected,
                  other: String(date.getTime() / 1000)
                });
              }
            }
          })
        }));
      }

    case ChoiceDataType.CHOICE_DATA_TYPE_DATE_TIME:
      {
        return /*#__PURE__*/_jsx(SingleChoiceWrapper, _objectSpread(_objectSpread({}, props), {}, {
          children: /*#__PURE__*/_jsx(DateTime, {
            id: id,
            values: other,
            setValues: function setValues(value) {
              return setFieldValue("".concat(id, ".other"), value);
            },
            minDate: addBusinessDays(new Date(), 3),
            inputFieldHint: singleChoiceAnswer.otherFieldHint,
            inputFieldHintTime: singleChoiceAnswer === null || singleChoiceAnswer === void 0 ? void 0 : singleChoiceAnswer.otherFieldHintTime,
            isDisabled: isDisabled
          })
        }));
      }

    case ChoiceDataType.CHOICE_DATA_TYPE_POSTAL_ADDRESS:
      {
        var setNestedValues = function setNestedValues(nestedValues) {
          return setFieldValue(id, {
            selected: selected,
            other: nestedValues
          });
        };

        return /*#__PURE__*/_jsx(SingleChoiceWrapper, _objectSpread(_objectSpread({}, props), {}, {
          children: /*#__PURE__*/_jsx(AddressFormElements, {
            fieldNamePrefix: "".concat(id, ".other."),
            values: other,
            setValues: setNestedValues
          })
        }));
      }

    default:
      return null;
  }
};